<template>
  <div>
    <transition name="custom" duration="1200">
      <app-popin
        v-if="introIndex === 0 && visible"
        title="Prêt.e à faire campagne? Ramasse les votes pour gagner des points"
        :image="$device.isMobile ? '/images/tuto--1--mobile.png'  : '/images/tuto--1.png'"
        svg="interrogation"
        pictoColor="blue"
        cta="J'ai compris"
        @onClick="onNext"
      />
    </transition>
    <transition name="custom" duration="1200">
      <app-popin
        v-if="introIndex === 1 && visible"
        title="Et évite les embuches qui t’en feront perdre"
        :image="$device.isMobile ? '/images/tuto--2--mobile.png'  : '/images/tuto--2.png'"
        svg="interrogation"
        pictoColor="blue"
        cta="Commencer"
        @click="onNext"
      />
    </transition>
  </div>
</template>

<script>
import AppPopin from '@/components/common/AppPopin'

export default {
  components: {
    AppPopin
  },

  data () {
    return {
      introIndex: -1,
      visible: false
    }
  },

  mounted () {
    requestAnimationFrame(() => {
      this.visible = true
      this.introIndex = 0
    })
  },

  methods: {
    onNext () {
      this.introIndex++
      this.visible = false

      setTimeout(() => {
        if (this.introIndex > 1) {
          this.$emit('end')
        }
        else {
          this.visible = true
        }
      }, 1300)
    }
  }
}

</script>

<style lang="stylus">
@import '~@/styles/settings/variables'

.intro
  &:before
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    border-radius 30px
    background-color: $colors.white
</style>